import React from "react";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.submit.dialog`;

/**
 * DBCO-0031 (R-09) - the one confirmation Submit raises when the server's Remained is not 0. The direction
 * comes from comparing the figure, and the amount is the same figure with its sign dropped as TEXT (HLD 5.3,
 * the RemainedWarning pattern): nothing is computed. Both directions, and no figure at all, can be confirmed.
 */
const SubmitVarianceDialog: React.FC<{
  open: boolean;
  remained: number | null;
  isSubmitting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, remained, isSubmitting = false, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const amount = remained === null ? "" : String(remained).replace(/^-/, "");
  const message =
    remained === null
      ? t(`${L}.unknown`)
      : remained > 0
        ? t(`${L}.under`, { quantity: amount })
        : t(`${L}.over`, { quantity: amount });
  return (
    <GenericDialog
      open={open}
      testId="drybulk-cargo-operation-submit-dialog"
      title={t(`${L}.title`)}
      content={message}
      cancelButtonText={t(`${L}.cancel`)}
      confirmButtonText={t(`${L}.confirm`)}
      handleCloseDialog={onCancel}
      confirmAction={onConfirm}
      isSubmitting={isSubmitting}
    />
  );
};

export default SubmitVarianceDialog;
